import React, { createContext, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import {
  applyFeatureFlagOverrides,
  checkFeatureFlags
} from "../../mp-utils/generic-utils"
import { User } from "../../mp-database"
import { RootState } from "../redux/store"
import { FeatureFlagContextType } from "./types"
import { FeatureFlagStatesType } from "../../mp-utils/generic-utils/feature-flags/types"

export const FeatureFlagContext = createContext<FeatureFlagContextType>({
  featureFlags: {},
  featureFlagsLoading: false
})

type Props = {}

export const FeatureFlagProvider: React.FC<Props> = ({ children }) => {
  const user = useSelector((state: RootState) => state.users.testUser as User)

  const [enabled, setEnabled] = useState<FeatureFlagStatesType>({})
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    let isMounted = true

    const setupFeatureFlagsState = async () => {
      setLoading(true)

      try {
        const featureFlagsState = await checkFeatureFlags({
          userId: user?.email
        })

        if (isMounted) {
          setEnabled(applyFeatureFlagOverrides(featureFlagsState))
        }
      } catch (error) {
        console.warn("[FeatureFlagProvider]", error)
      } finally {
        setLoading(false)
      }
    }

    setupFeatureFlagsState()

    return () => {
      isMounted = false
    }
  }, [user])

  return (
    <FeatureFlagContext.Provider
      value={{
        featureFlags: enabled,
        featureFlagsLoading: loading
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  )
}
